import React from 'react'
import { ActionIconButton } from '../ActionIconButton/ActionIconButton'
import { ConfirmationDialog } from '../ConfirmationDialog/ConfirmationDialog'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'

interface Props {
  onClick?: () => void
  isLoading?: boolean
  confirmationBody?: any
}

export const DeleteIconButton: React.FC<Props> = ({ onClick, isLoading, confirmationBody }) => {
  return (
    <ConfirmationDialog body={<div>{confirmationBody || 'Are you sure?'}</div>}>
      {(confirm: any) => (
        <ActionIconButton
          onClick={confirm((e: any) => () => new Promise(() => onClick && onClick()))}
          isLoading={isLoading}
          color="secondary"
        >
          <DeleteOutlinedIcon />
        </ActionIconButton>
      )}
    </ConfirmationDialog>
  )
}
